// extracted by mini-css-extract-plugin
module.exports = {"container":"PreInput_container___K1DL","popularSearchesContainer":"PreInput_popularSearchesContainer__30iiP","popularSearchItem":"PreInput_popularSearchItem__R2cQD"};